/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import { collection, doc } from 'firebase/firestore';
import { db } from '.';
import { isDev } from './api/qdot';
import { firebaseFacade } from './api/firebase';
import Schemas from './api/schemas';
import { configContext } from './api/config';
export const MISTERY_WALLET = 'Mistery';

const { queue_schema } = Schemas;

export async function log(data) {
  if (
    configContext
      .fetchValue(configContext.configKeys.loggingEnabled)
      .asBoolean()
  ) {
    await firebaseFacade.insertDocument(doc(collection(db, 'logs')), {
      data: data,
      timestamp: Date.now(),
      component: data.component || null,
    });
  } else if (isDev()) {
    console.log(data);
  }
}

export function isOrphaned(queue) {
  return queue && queue[queue_schema.owner_wallet_address] === MISTERY_WALLET;
}

export const textTruncate = (target, size) => {
  if (
    target === undefined ||
    target === null ||
    size === undefined ||
    size === null ||
    size === 0
  )
    return target;

  const trunc = target.substring(0, size);
  if (trunc.length == target.length) return target;
  return `${trunc}...`;
};

export function sameQueue(first, second) {
  log({
    msg: 'sameQueue called',
    params: {
      first: first,
      second: second,
      result: first.queue_address === second.queue_address,
    },
  });
  return first.queue_address === second.queue_address;
}
